import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CRow,
  CSmartTable,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CModalFooter,
  CTableRow,
  CTableDataCell,
  CTableBody,
  CTableHeaderCell,
  CModalHeader,
  CModal,
  CModalBody,
  CTable,
  CTableHead,
} from '@coreui/react-pro'
import { toast } from 'react-toastify'

import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import UserService from 'src/service/UserService'
import CommonService from 'src/service/CommonService'
const AdminPricingPlan = () => {
  const [loading, setLoading] = useState()
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState([])
  const gameTypeLabels = {
    1: 'Season Game',
    2: 'Tournament Game (For Leagues)',
    3: 'Tournament Game (For Indoor Leagues)',
    4: 'Match Contest',
  }
  const columns = [
    {
      label: 'Hub Name',
      key: 'club_name',
    },
    {
      label: 'Game Name',
      key: 'game_name',
    },
    {
      label: 'Game Type',
      key: 'game_type',
    },
    {
      label: 'Email',
      key: 'email',
    },
    { label: 'Status', filter: false, key: 'membership_is_paid' },
    {
      key: 'action',
      label: 'Action',
      filter: false,
      sorter: false,
    },
  ]

  useEffect(() => {
    fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
  }, [activePage, columnFilter, columnSorter, itemsPerPage])

  const fetchData = (activePage, columnFilter, columnSorter, itemsPerPage) => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    UserService.adminPricingPlanUsers(offset, itemsPerPage, activePage, params).then((result) => {
      setUsers(result.data)
      setLoading(false)
    })
  }

  const [visibleModal, setVisibleModal] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState(null)
  const tableData = [
    { tier: '1-4 Teams', min_teams: 1, max_teams: 4, fee: '150' },
    { tier: '5-8 Teams', min_teams: 5, max_teams: 8, fee: '200' },
    { tier: '9-12 Teams', min_teams: 9, max_teams: 12, fee: '250' },
    { tier: '13-16 Teams', min_teams: 13, max_teams: 16, fee: '300' },
    { tier: '17-20 Teams', min_teams: 17, max_teams: 20, fee: '350' },
    { tier: '21+ Teams', min_teams: 21, max_teams: null, fee: '400' },
  ]
  const totalPaidAmount = 100
  const [paidPlanTypes, setPaidPlanTypes] = useState([])
  const handlePayNow = (fee, tier, planType, min, max) => {
    // toast.success(`Proceeding to payment of AUD ${fee} for ${tier}`)
    const quoteData = {
      user_id: selectedUserId,
      plan_type: planType,
      team_tier: tier,
      min_teams: min,
      max_teams: max,
      amount: fee,
    }
    CommonService.saveGameUserPricingPlanByAdmin(quoteData)
      .then((res) => {
        ToastComponent(res?.message || 'Pricing plansss saved successfully', 'success')
        fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
        setVisibleModal(false)
      })
      .catch((error) => {
        console.error('Error saving pricing quota:', error)
        const status = error?.status
        const message = error?.message

        if (status === 409 && message) {
          ToastComponent(message, 'error') // Show backend duplicate error
        } else {
          ToastComponent('Error saving pricing quota', 'error')
        }
      })
    // Integrate your payment logic here
  }

  const showPriceTable = (userId, extra) => {
    CommonService.getPurchasePricingPlanByUser(userId).then((res) => {
      setPaidPlanTypes(res?.data || [])
    })
    setSelectedUserId(userId)
    setVisibleModal(true)
  }
  return (
    <>
      <CRow>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              {' '}
              <strong>Do It Yourself</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <CSmartTable
                columns={columns}
                columnFilter={{
                  external: true,
                }}
                columnSorter={{
                  external: true,
                }}
                scopedColumns={{
                  membership_is_paid: (item) => {
                    return (
                      <td>
                        {item?.membership_is_paid ? (
                          <CBadge color={'success'}>Paid </CBadge>
                        ) : (
                          <CBadge color={'danger'}>Unpaid</CBadge>
                        )}
                      </td>
                    )
                  },
                  game_type: (item) => {
                    return <td>{gameTypeLabels[item.game_type] || '-'}</td>
                  },
                  action: (item) => {
                    return (
                      <>
                        <td>
                          <CButton
                            color="primary"
                            variant="outline"
                            shape="square"
                            size="sm"
                            onClick={() => {
                              showPriceTable(item.game_id, 0)
                            }}
                          >
                            Show Price
                          </CButton>
                        </td>
                      </>
                    )
                  },
                }}
                items={users?.data}
                itemsPerPage={itemsPerPage}
                itemsPerPageSelect
                loading={loading}
                pagination={{
                  external: true,
                }}
                paginationProps={{
                  activePage: activePage,
                  pages: Math.ceil(users?.total / itemsPerPage) || 1,
                }}
                tableProps={{
                  hover: true,
                  responsive: true,
                }}
                onActivePageChange={(activePage) => setActivePage(activePage)}
                onColumnFilterChange={(filter) => {
                  setActivePage(1)
                  setColumnFilter(filter)
                }}
                onItemsPerPageChange={(itemsPerPage) => {
                  setActivePage(1)
                  setItemsPerPage(itemsPerPage)
                }}
                onSorterChange={(sorter) => setColumnSorter(sorter)}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>

      <CModal
        visible={visibleModal}
        onClose={() => setVisibleModal(false)}
        size="lg"
        backdrop="static"
      >
        <CModalHeader>
          <strong>Pricing Table</strong>
        </CModalHeader>
        <CModalBody>
          <CTable bordered className="mt-3">
            <CTableHead>
              <CTableRow color="warning">
                <CTableHeaderCell>Team Tiers</CTableHeaderCell>
                <CTableHeaderCell>Game Fee (in AUD)</CTableHeaderCell>
                <CTableHeaderCell>Action</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {tableData.map((item, index) => {
                const originalFee = parseInt(item.fee)
                const planType = index + 1
                const isPaid = paidPlanTypes.includes(planType)

                return (
                  <CTableRow key={index}>
                    <CTableDataCell>{item.tier}</CTableDataCell>
                    <CTableDataCell>AUD {originalFee}</CTableDataCell>
                    <CTableDataCell>
                      <CButton
                        color="primary"
                        size="sm"
                        onClick={() =>
                          handlePayNow(
                            originalFee,
                            item.tier,
                            planType,
                            item.min_teams,
                            item.max_teams,
                          )
                        }
                        disabled={originalFee === 0}
                      >
                        {isPaid ? 'Paid' : 'Pay Now'}
                      </CButton>
                    </CTableDataCell>
                  </CTableRow>
                )
              })}
            </CTableBody>
          </CTable>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisibleModal(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default AdminPricingPlan
